import SeoHead from '../components/SeoHead'
import { SITE, mailto } from '../lib/site'

export default function GizlilikPage() {
  return (
    <>
      <SeoHead
        title="Gizlilik ve KVKK — W.Sign"
        description="W.Sign gizlilik politikası ve KVKK aydınlatma metni: hangi veriler işlenir, belgeler nasıl saklanır, telemetri toplanmaz."
        path="/gizlilik"
      />

      <section className="container-page pt-16 pb-8 md:pt-20">
        <div className="max-w-2xl">
          <span className="badge">Gizlilik &amp; KVKK</span>
          <h1 className="mt-4 text-3xl md:text-4xl font-semibold tracking-tight">
            Gizlilik Politikası ve KVKK Aydınlatma Metni
          </h1>
          <p className="mt-4 text-[var(--color-fg-muted)]">
            {SITE.company} olarak kişisel verilerinizin güvenliğine önem veriyoruz. Bu metin,
            W.Sign ürün ve hizmetlerini kullanırken hangi verilerin, hangi amaçla işlendiğini
            açıklar.
          </p>
        </div>
      </section>

      <section className="container-page pb-20">
        <div className="prose-doc max-w-3xl space-y-8">
          <Block title="1. Veri sorumlusu">
            Bu politika kapsamındaki veri sorumlusu {SITE.company}’dır ({SITE.city}).
            Sorularınız için: <a className="text-[var(--color-accent)] hover:underline" href={mailto(SITE.email.kvkk)}>{SITE.email.kvkk}</a>
          </Block>

          <Block title="2. İşlenen veriler">
            <ul className="list-disc pl-5 space-y-1.5">
              <li><strong>Hesap bilgileri:</strong> e-posta adresiniz (şifresiz giriş bağlantısı ve bildirimler için), varsa parola özetiniz.</li>
              <li><strong>Belge verileri:</strong> portala yüklediğiniz veya oluşturduğunuz belgeler, yalnızca imza ve doğrulama işlemini gerçekleştirmek için.</li>
              <li><strong>İmza üstverisi:</strong> imzalayan sertifika bilgisi, zaman damgası, doğrulama sonucu gibi teknik kayıtlar.</li>
              <li><strong>Teknik kayıtlar:</strong> hata teşhisi ve güvenlik amacıyla tutulan sunucu günlükleri.</li>
            </ul>
          </Block>

          <Block title="3. Toplamadığımız veriler">
            W.Sign ürünleri <strong>kullanım telemetrisi / davranışsal izleme</strong> yapmaz.
            Nitelikli imza işlemlerinde <strong>özel anahtarınız (PIN ile korunan kart)
            cihazınızdan çıkmaz</strong>; imza, token üzerinde üretilir.
          </Block>

          <Block title="4. Belgelerin saklanması">
            <p>
              <strong>Portal (sign.wsoft.tr):</strong> imza akışını tamamlamak için belgeleriniz
              hesabınıza bağlı olarak saklanır; dilediğiniz zaman silebilirsiniz.
            </p>
            <p className="mt-2">
              <strong>Sunucu / Kurumsal lisans:</strong> W.Sign’ı kendi altyapınızda
              çalıştırdığınızda belgeler hiçbir zaman {SITE.company} sunucularına gelmez —
              veri tamamen sizde kalır.
            </p>
          </Block>

          <Block title="5. İşleme amaçları ve hukuki sebep">
            Veriler; sözleşmenin (hizmetin) ifası, talep ettiğiniz imza/doğrulama işleminin
            gerçekleştirilmesi, yasal yükümlülüklerin yerine getirilmesi ve hizmet güvenliğinin
            sağlanması amacıyla, 6698 sayılı KVKK m.5 kapsamında işlenir.
          </Block>

          <Block title="6. Aktarım">
            Verileriniz, hizmetin gerektirdiği altyapı sağlayıcıları (barındırma, e-posta
            gönderimi) dışında üçüncü kişilerle paylaşılmaz, pazarlama amacıyla satılmaz.
          </Block>

          <Block title="7. Haklarınız">
            KVKK m.11 kapsamında; verilerinize erişme, düzeltilmesini veya silinmesini isteme
            haklarına sahipsiniz. Başvurularınızı <a className="text-[var(--color-accent)] hover:underline" href={mailto(SITE.email.kvkk)}>{SITE.email.kvkk}</a> adresine iletebilirsiniz.
          </Block>

          <Block title="8. Çerezler">
            Portal, oturumunuzu sürdürmek için gerekli teknik çerez/yerel depolama kullanır.
            Reklam veya üçüncü taraf izleme çerezi kullanılmaz.
          </Block>

          <div className="rounded-md border border-[var(--color-border)] bg-[var(--color-bg-soft)] p-4 text-sm text-[var(--color-fg-muted)]">
            Bu metin bilgilendirme amaçlıdır ve hizmetin gelişimine göre güncellenebilir.
            Güncel sürüm bu sayfada yayımlanır.
          </div>
        </div>
      </section>
    </>
  )
}

function Block({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div>
      <h2 className="text-lg font-semibold text-[var(--color-fg)]">{title}</h2>
      <div className="mt-2 text-[var(--color-fg-muted)]">{children}</div>
    </div>
  )
}
